// --------------------------------------------------------------------------
// filter.js
// --------------------------------------------------------------------------
// Hide/Shows results trigged by filters
// --------------------------------------------------------------------------

EC.filter = function () {

    'use strict';

    let $resultsContainer;
    let filter;

    function init () {
        $('.js-filter').on('click', toggleFilter);
        $resultsContainer = $('#js-filter-results');
    }

    function toggleFilter () {
        filter = this.value;

        $('#js-filter-no-results').remove();

        if(filter === 'all' ){
            showAll();
        }
        else{
           applyFilter(filter); 
        }
    }

    function applyFilter (filter) {
        const $results = $('.' + filter);
        if ($results.length > 0){
            $resultsContainer.children().not($results).fadeOut();
            $results.fadeIn();
        }
        else{
            displayNoResults();
        }
    }

    function showAll () {
        $resultsContainer.children().fadeIn();
    }

    function displayNoResults () {
        const readableFilters = humanReadable(filter);

        const noResultsHTML = `
            <div class="e-no-results" id="js-filter-no-results">
                <p class="e-no-results__heading">No results found</p>
                <p class="e-no-results__copy">There are no results that match ${readableFilters}.</p>
            </div>
        `;

        $resultsContainer.children().fadeOut();
        setTimeout(function(){
            $resultsContainer.prepend(noResultsHTML);
        }, 400)
    }

    function humanReadable(string){
        return `<span class="e-no-results__filter">${string.replace('-', ' ')}</span>`;
    }

    return {
        init: init
    };

}();